var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartgit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 31.832032,18.117188 12,32 27.117188,42.582032 28.308594,36.414062 22,32 30.273438,26.207032 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 37.253906,21.679688 -1.1875,6.167968 L 42,32 34.214844,37.449218 32.65625,45.539062 52,32 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartgit);
export default __webpack_public_path__ + "static/media/smartgit.ffa8c7c8fae0c888f2876bae004b2345.svg";
export { ForwardRef as ReactComponent };